export const isWidgetAppType = (): boolean => {
  return window !== window.parent;
};
